export default "__VITE_ASSET__j8Wq7Bi5__"